import gql from 'graphql-tag'

export default gql`
mutation($types : String){
  updateAllrunnerReport(types : $types)
}
`